<template>
    <div>
        <label class="relative inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                v-model="darkMode"
                class="sr-only peer"
            />
            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            <span class="ms-3 text-sm font-medium text-gray-100">Dark</span>
        </label>
    </div>
</template>

<script>
import {useDarkModeStore} from "../stores/darkMode";
import InputCheckbox from "./form/InputCheckbox.vue";

export default {
    name: "DarkMode",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    components: {InputCheckbox},
    data() {
        return {
            darkModeStore: useDarkModeStore(),
        };
    },
    mounted() {
        this.darkModeStore.darkMode = !!this.user.dark_mode;
    },
    computed: {
        darkMode: {
            get() {
                return this.darkModeStore.darkMode;
            },
            async set(newValue) {
                this.darkModeStore.darkMode = !!newValue;
                await axios.patch(route('api.users.update-dark-mode', {user: this.user}), {dark_mode: !!newValue})
                    .catch(err => {
                        console.log(err?.response?.data || err)
                    });
            }
        }
    },
};
</script>

